
<template>
	<div>
    <div class="header_body">
      <span class="header_title">{{curObj.title}}</span>
      <div class="header_content">
        <span>{{curObj.createTime}} 观看{{curObj.watchNum}}次</span>
      </div>
    </div>
		<bctos-rich-text v-if="content" :nodes="content" :cover="cover" :width="width"></bctos-rich-text>
	</div>
</template>
<script>
import bctosRichText from '@/components/RichText/index';
import { detNews } from '@/api/news'
import config from '@/config';
export default {
  components:{bctosRichText},
  data(){
    return{
      type: '',
      curId: '',
      content: '',
      cover: '',
      curObj: '',
      width: document.documentElement.clientWidth,
      myImgBaseUrl: config.imgBaseUrl,
    }
  },
  created(){
    this.type = this.getUrlKey('type');
    this.curId = this.getUrlKey('id');
    this.getNewsDet();
  },
  mounted(){
      
  },
  methods:{
    getUrlKey(name){//获取url 参数
      return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
    },
    getNewsDet(){
      detNews(this.curId).then(res=>{
        if (res) {
          this.content = res.data.content;
          this.curObj = res.data;
          this.cover = this.myImgBaseUrl + res.data.cover;
        }
      })
    }

  }
}
</script>
<style scoped>
.header_body{
  padding-top: 10px;
  text-align: center;
}
.header_title{
  font-size: 25px;
  font-weight: bold;
}
.header_content{
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 12px;
  color: #808080;
}

</style>
